// tab
document.addEventListener("DOMContentLoaded", function () {
	const miniImgDropItems = document.querySelectorAll(".mm-wrapper-mini-img-drop");
	const imgDropFullItems = document.querySelectorAll(".mm-wrapper-img-drop-full");

	miniImgDropItems.forEach(function (miniImgDropItem, index) {
		miniImgDropItem.addEventListener("click", function () {
			miniImgDropItems.forEach((item) => item.classList.remove("active"));
			imgDropFullItems.forEach((item) => item.classList.remove("active"));
			this.classList.add("active");
			imgDropFullItems[index].classList.add("active");
		});
	});

	miniImgDropItems[0].click();
});

// play video
document.addEventListener("DOMContentLoaded", function () {
	const videoContainers = document.querySelectorAll(".mm-wrapper-img-drop-full");

	videoContainers.forEach((container) => {
		const video = container.querySelector(".mm-video-iframe");
		const playBtn = container.querySelector(".video-btn");
		const bgVideo = container.querySelector(".mm-bg-video-drop");
		const timerWrapper = container.querySelector(".mm-wrapper-timer-drop");
		const infoWrapper = container.querySelector(".mm-mini-img-drop-title");

		if (!video || !playBtn) return;

		const togglePlayPause = () => {
			if (video.paused) {
				video.play();
				playBtn.classList.add("playing");
				playBtn.style.display = "none";
			} else {
				video.pause();
				playBtn.classList.remove("playing");
				playBtn.style.display = "flex";
			}
		};

		// Click sur le bouton play
		playBtn.addEventListener("click", togglePlayPause);

		// Click sur le background video (pour plus de surface cliquable)
		video.addEventListener("click", togglePlayPause);

		// Mise à jour visuelle du bouton
		video.addEventListener("pause", () => {
			playBtn.classList.remove("playing");
			playBtn.style.display = "flex";
			timerWrapper.style.display = "flex";
			infoWrapper.style.display = "flex";
			bgVideo.style.display = "flex";
			initializeVideoTimer();
		});

		video.addEventListener("play", () => {
			playBtn.classList.add("playing");
			playBtn.style.display = "none";
			timerWrapper.style.display = "none";
			infoWrapper.style.display = "none";
			bgVideo.style.display = "none";
		});
	});
});

// timer
function initializeVideoTimer() {
	var videos = document.querySelectorAll(".mm-video-iframe");
	var timers = document.querySelectorAll(".mm-timer-video-drop");

	videos.forEach(function (video, index) {
		if (video) {
			video.addEventListener("loadedmetadata", function () {
				var duration = Math.round(video.duration);
				var minutes = Math.floor(duration / 60);
				var seconds = duration % 60;

				timers[index].textContent = minutes + "min" + seconds + "sec";
			});
		}
	});
}

document.addEventListener("DOMContentLoaded", initializeVideoTimer);

// sound video
function mmToggleVideoSound(clickedElem) {
	// Choper la vidéo liée à notre bouton
	const videoContainer = clickedElem.closest(".mm-wrapper-img-drop-full");
	const videoElement = videoContainer.querySelector(".mm-video-iframe");
	const videoSound = videoContainer.querySelector(".mm-sound");
	const videoMuted = videoContainer.querySelector(".mm-muted");

	//mute la video
	if (videoElement.muted == true) {
		// if la video est muted : on la unmute
		videoElement.muted = false;
		videoSound.style.display = "block";
		videoMuted.style.display = "none";
	} else {
		// else on la mute
		videoElement.muted = true;
		videoSound.style.display = "none";
		videoMuted.style.display = "block";
	}
}

// dropdown
let collFaq = document.querySelectorAll(".mm-id-faq");
let i;

for (i = 0; i < collFaq.length; i++) {
	collFaq[i].addEventListener("click", function () {
		this.classList.toggle("active");
		const content = this.nextElementSibling;
		if (content.style.maxHeight) {
			content.style.maxHeight = null;
		} else {
			content.style.maxHeight = content.scrollHeight + "px";
		}
	});
}

// Rotate card
Splitting();

gsap.config({
	nullTargetWarn: false,
	autoKillThreshold: 0.01,
});

// Utilisation de ScrollTrigger sans smooth
gsap.to(".mm-wrapper-right-box", {
	rotate: "15deg",
	ease: "none",
	scrollTrigger: {
		trigger: ".mm-wrapper-right-box",
		start: "top bottom",
		end: "bottom top",
		scrub: true,
	},
});

const rightBox = document.querySelector(".mm-wrapper-right-box");
// quitte mm-wrapper-right-box
if (rightBox) {
	rightBox.addEventListener("mouseleave", function () {
		gsap.to(".mm-wrapper-right-box", {
			rotate: "0deg", // Rotation de retour à 0 degré
			ease: "none",
		});
	});
}

// Mouvement vertical
gsap.to(".mm-pointer-card", {
	y: 20,
	duration: 0.5,
	ease: "bounce.out",
	yoyo: true,
	repeat: 100,
});

function raf(time) {
	requestAnimationFrame(raf);
	ScrollTrigger.update();
}
requestAnimationFrame(raf);
